import React from "react";

interface StatusDotProps {
  classType?: string;
}

export const StatusDot: React.FC<StatusDotProps> = ({ classType }) => {
  const isNonMandatory =
    classType === "FIRST_NON_MANDATORY" || classType === "NEXT_NON_MANDATORY";

  if (isNonMandatory) {
    return (
      <svg
        width="17"
        height="22"
        viewBox="0 0 17 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.3764 14.0252C15.8414 9.62075 12.9925 5.63297 9.01309 5.11823C5.03368 4.60348 1.43071 7.75667 0.965634 12.1611C0.500556 16.5655 3.34949 20.5533 7.3289 21.068C11.3083 21.5828 14.9113 18.4296 15.3764 14.0252Z"
          fill="#006E5E"
        />
        <path
          d="M8.81245 19.106C12.7912 18.5853 15.6566 14.7935 15.2125 10.6368C14.7684 6.48019 11.183 3.5327 7.20421 4.05344C3.22543 4.57419 0.360016 8.36598 0.804119 12.5226C1.24822 16.6793 4.83367 19.6268 8.81245 19.106Z"
          fill="#00B282"
        />
        <path
          d="M11.4745 11.0756C13.1655 8.70198 12.7978 5.26055 10.6532 3.38895C8.50866 1.51735 5.39932 1.9243 3.70831 4.29791C2.01731 6.67151 2.385 10.1129 4.52956 11.9845C6.67413 13.8561 9.78347 13.4492 11.4745 11.0756Z"
          fill="#006E5E"
        />
        <path
          d="M8.00831 11.5796C10.7205 11.2246 12.6698 8.60351 12.3623 5.72522C12.0548 2.84693 9.60684 0.801371 6.89468 1.15634C4.18252 1.51131 2.23318 4.13239 2.5407 7.01068C2.84822 9.88897 5.29615 11.9345 8.00831 11.5796Z"
          fill="#00CB88"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width="17"
        height="22"
        viewBox="0 0 17 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.3764 14.0252C15.8414 9.62075 12.9925 5.63297 9.01309 5.11823C5.03368 4.60348 1.43071 7.75667 0.965634 12.1611C0.500556 16.5655 3.34949 20.5533 7.3289 21.068C11.3083 21.5828 14.9113 18.4296 15.3764 14.0252Z"
          fill="#BFA400"
        />
        <path
          d="M8.81245 19.106C12.7912 18.5853 15.6566 14.7935 15.2125 10.6368C14.7684 6.48019 11.183 3.5327 7.20421 4.05344C3.22543 4.57419 0.360016 8.36598 0.804119 12.5226C1.24822 16.6793 4.83367 19.6268 8.81245 19.106Z"
          fill="#FBDD12"
        />
        <path
          d="M11.4745 11.0756C13.1655 8.70198 12.7978 5.26055 10.6532 3.38895C8.50866 1.51735 5.39932 1.9243 3.70831 4.29791C2.01731 6.67151 2.385 10.1129 4.52956 11.9845C6.67413 13.8561 9.78347 13.4492 11.4745 11.0756Z"
          fill="#C1A80A"
        />
        <path
          d="M8.00831 11.5796C10.7205 11.2246 12.6698 8.60351 12.3623 5.72522C12.0548 2.84693 9.60684 0.801371 6.89468 1.15634C4.18252 1.51131 2.23318 4.13239 2.5407 7.01068C2.84822 9.88897 5.29615 11.9345 8.00831 11.5796Z"
          fill="#FFE831"
        />
      </svg>
    );
  }
};
